import React from 'react'
import { ContactInfo } from '../../Utils/Data'
import { useLanguage } from '../../Utils/LanguageContext'

/**
 * Fixed bottom-end support button — opens WhatsApp chat.
 */
function WhatsAppSupport() {
  const href = ContactInfo.contact_whatsapp || 'https://wa.me/966552690995'
  const { isArabic } = useLanguage()
  const label = isArabic ? 'الدعم' : 'Support'

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="site-support-btn no-translate"
      data-no-translate
      aria-label={isArabic ? 'الدعم عبر واتساب' : 'Customer support on WhatsApp'}
      title={label}
    >
      <i className="ph-fill ph-headset" aria-hidden="true" />
      <span className="site-support-btn__label">{label}</span>
      <style>{`
        .site-support-btn {
          position: fixed;
          z-index: 9999;
          bottom: 24px;
          inset-inline-end: 24px;
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 12px 18px 12px 14px;
          border-radius: 999px;
          background: #111;
          color: #fff;
          text-decoration: none;
          box-shadow: 0 4px 18px rgba(0, 0, 0, 0.28);
          transition: transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
        }
        .site-support-btn:hover {
          color: #fff;
          background: #222;
          transform: translateY(-2px);
          box-shadow: 0 8px 22px rgba(0, 0, 0, 0.32);
        }
        .site-support-btn i {
          font-size: 1.45rem;
          line-height: 1;
          color: #feee00;
        }
        .site-support-btn__label {
          font-size: 0.9rem;
          font-weight: 700;
          letter-spacing: 0.02em;
          line-height: 1;
        }
        @media (max-width: 575px) {
          .site-support-btn {
            bottom: 18px;
            inset-inline-end: 16px;
            padding: 11px 14px 11px 12px;
            gap: 6px;
          }
          .site-support-btn__label {
            font-size: 0.82rem;
          }
        }
      `}</style>
    </a>
  )
}

export default WhatsAppSupport
